// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__35nbM","inner":"Footer_inner__3G--X"};